<script setup lang="ts">
import { Coupon } from '@/@types/cart'
import Badge from '@/components/ui/badge/Badge.vue'
import { Card, CardTitle } from '@/components/ui/card'
import { DonutChart } from '@/components/ui/chart-donut'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const { coupon } = defineProps<{ coupon: Coupon }>()

const data = [
    {
        name: t('Available'),
        total: coupon.usage_limit - coupon.usage_count,
    },
    {
        name: t('Used'),
        total: coupon.usage_count,
    },
]
</script>

<template>
    <Card class="w-full max-w-sm border-none p-10">
        <CardTitle class="mb-8 text-2xl font-semibold text-gray-800">
            {{ $t('Coupons') }}
        </CardTitle>
        <DonutChart index="name" category="total" :data="data" :colors="['#FDBA74', '#6366F1']" />
        <div class="flex justify-center gap-8 pt-8">
            <Badge
                class="bg-transparent text-nowrap text-gray-500 shadow-none before:size-3 before:rounded-full before:bg-orange-300 before:content-[''] hover:bg-transparent"
                >{{ $t('Available coupons') }}</Badge
            >
            <Badge
                class="bg-transparent text-nowrap text-gray-500 shadow-none before:size-3 before:rounded-full before:bg-indigo-500 before:content-[''] hover:bg-transparent"
                >{{ $t('Used coupons') }}</Badge
            >
        </div>
    </Card>
</template>

<style>
.css-xwzpmf-central-label {
    font-size: 30px;
}
</style>
